module.exports = __webpack_public_path__ + "static/media/company_icon.71ae0a24.svg";